import React from 'react'
import './HomePage.scss'
import GameRoutes from '../../route/gameroutes/GameRoutes'
import SearchBar from '../../route/searchbar/SearchBar'
import logo2 from '../../assets/logo-vc-2.png'

const HomePage = () => {
    return (
        <>
            <div className="homepage__white">
                <div className="homepage__container">
                    <SearchBar/>
                    <GameRoutes/>
                    <div className="homepage__slogan">
                        <img src={logo2} alt="logo2"/>
                        <div className="homepage__slogan-wrap">
                            <h1>To <span>Win</span> The Game <br/>Just Remain <br/>In The <span>Game</span></h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HomePage
